import * as React from 'react';

// tslint:disable:max-line-length
export const Graphique = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='82' height='71' viewBox='0 0 82 71'>
    <path
      d='M66 11.1l-.5 3.1-2.5-2.5 3-.6zm14.7 57.3H2.6V57.8l.6-.3 15.4-15.4 8.1 8.1c.5.5 1.3.5 1.8 0l34.7-34.7 2.3 2.2c.2.2.6.4.9.4.1 0 .3 0 .4-.1.5-.1.8-.5.9-1L69 9.7c.1-.4-.1-.8-.4-1.1s-.7-.4-1.1-.4l-7.3 1.3c-.5.1-.9.4-1 .9s0 1 .3 1.3l2 2-34 33.7-8.1-8.1c-.5-.5-1.3-.5-1.8 0l-15 15.2V1.3C2.6.6 2 0 1.3 0S0 .6 0 1.3v68.4c0 .7.6 1.3 1.3 1.3h79.4c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3z'
      fill='#6744C6'
    />
  </svg>
);


// WEBPACK FOOTER //
// src/app/src/components/Icons/Graphique.tsx